import React, { Fragment } from "react";
import { IntlProvider } from "react-intl";

export default function Provider({
  children,
  locale="en",
  translations
}) {
  const messages = translations && translations.some(translation => translation.code === locale) ? translations.find(translation => translation.code === locale).translations : [];
  
  return ( 
    <IntlProvider
      locale={locale}
      textComponent={Fragment}
      messages={messages}
      onError={() => null}
    >
      {children}
    </IntlProvider>
  );
}
